angular.module('app').directive('inputFormat', function ($filter) {
    'ngInject';

    return {
        'restrict': 'A',
        'require': '?ngModel',
        'link': function (scope, elem, attrs, ctrl) {
            if (!ctrl) return;

            ctrl.$formatters.unshift(function (a) {
                return $filter(attrs.inputFormat)(ctrl.$modelValue);
            });

            ctrl.$parsers.unshift(function (viewValue) {
                return Math.floor(parseFloat(viewValue)*100);
            });
        }
    };
});
